// client/src/services/campaignsApi.js
// API wrapper for On-Screen 2.0 marketing campaigns + the backward-planning
// timeline generator. Uses the shared fetch helpers in ./http.

import { getJson, postJson, putJson, patchJson, delJson } from './http';

const base = (tenantId) => `/api/tenants/${Number(tenantId)}`;

export async function listCampaigns(tenantId, { status, eventId } = {}) {
  const qs = new URLSearchParams();
  if (status) qs.set('status', status);
  if (eventId) qs.set('eventId', String(eventId));
  const q = qs.toString();
  return getJson(`${base(tenantId)}/campaigns${q ? `?${q}` : ''}`);
}

export async function getCampaign(tenantId, id) {
  return getJson(`${base(tenantId)}/campaigns/${Number(id)}`);
}

export async function createCampaign(tenantId, payload) {
  return postJson(`${base(tenantId)}/campaigns`, payload);
}

export async function updateCampaign(tenantId, id, payload) {
  return putJson(`${base(tenantId)}/campaigns/${Number(id)}`, payload);
}

export async function setCampaignStatus(tenantId, id, status) {
  return patchJson(`${base(tenantId)}/campaigns/${Number(id)}/status`, { status });
}

export async function archiveCampaign(tenantId, id) {
  return delJson(`${base(tenantId)}/campaigns/${Number(id)}`);
}

export async function getCampaignContent(tenantId, id) {
  return getJson(`${base(tenantId)}/campaigns/${Number(id)}/content`);
}

export async function getCampaignRoi(tenantId, id) {
  return getJson(`${base(tenantId)}/campaigns/${Number(id)}/roi`);
}

export async function listEventCampaigns(tenantId, eventId) {
  return getJson(`${base(tenantId)}/events/${Number(eventId)}/campaigns`);
}

/**
 * Backward-plan the promotion campaign off the event date.
 * @param {object} opts { createTasks?:boolean, createDraftPosts?:boolean }
 */
export async function generateEventPlan(tenantId, eventId, opts = {}) {
  return postJson(`${base(tenantId)}/events/${Number(eventId)}/generate-plan`, {
    createTasks: opts.createTasks !== false,
    createDraftPosts: opts.createDraftPosts !== false,
  });
}

export const CAMPAIGN_OBJECTIVES = ['awareness', 'registration', 'engagement', 'conversion', 'retention'];
export const CAMPAIGN_STATUSES = ['planning', 'active', 'paused', 'completed', 'archived'];
